module.exports = __webpack_public_path__ + "static/img/bg1.676447d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg1.png
// module id = yfdd
// module chunks = 4